/**
 *  © 2015 -2022 HCL Technologies Limited, all rights reserved.
 *  Material published by HCL Technologies on these web pages/mobile
 *  app may not be reproduced without permission.
 */

import React, { useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import Sponsor from '../../Common/Sponsor';
import { CONTENT_TYPE } from '../../../constants/globalConstants';
import { getSponsorData, getStatsBarData, transformUpsellData } from '../../../utils/utils';
import ImgCrop from '../../Common/ImgCrop';
import StatsBar from '../../Common/StatsBar';
import * as track from '../../../utils/analytics';
import { COLLECTION_MODAL } from '../../../constants/containerConstants';
import UpSell from '../../Common/UpSell';
const CollectionExplore = (props) => {
  const {
    t,
    data,
    itemid,
    showCollectionCard,
    lastCard,
    closeModal,
    trackCollectionExit,
    isDestinationPage,
    layoutId,
    upsell,
  } = props;
  const sponsorInfo = data.Sponsorby && getSponsorData(data.Sponsorby.fields);
  useEffect(() => {
    if (!lastCard) {
      let an = {};
      an.collectionTitle = data.ShortHeadline && data.ShortHeadline.value;
      an.collectionDestUrl =
        data.manutds && data.manutds.value && data.manutds.value.DestinationUrl;
      track.pageView(an, layoutId);
    }
  }, []);
  const shareCollection = (e) => {
    let el = e.currentTarget;
    let statsbarLi = el.querySelectorAll('.statsbar ul li');
    statsbarLi = statsbarLi && statsbarLi[2];
    statsbarLi.click();
  };
  return (
    <div className={`ratio collection__cover-img ${lastCard ? 'last-card' : ''}`}>
      <div className={`grid-12 cover-card ${lastCard ? 'lastcard' : ''}`}>
        <div className="mu-content">
          <div className="img-holder">
            {data.CoverImage && data.CoverImage.value && data.CoverImage.value.Crops && (
              <ImgCrop
                imgCrop={data.CoverImage.value.Crops}
                singleSrc={false}
                alt=""
                title={data.ShortHeadline && data.ShortHeadline.value}
                isWebpAvailable={data.CoverImage.value.isWebpAvailable}
              ></ImgCrop>
            )}
          </div>
          <Sponsor
            contentType={data.ContentType && data.ContentType.value}
            varient={data.Variant && data.Variant.value}
            sponsorInfo={sponsorInfo}
            grid={'grid-12'}
            type={CONTENT_TYPE}
            author={data.AuthorName && data.AuthorName.value}
            cardName={data.ShortHeadline && data.ShortHeadline.value}
            container={COLLECTION_MODAL}
            createdDateTime={data.__Published && data.__Published.value}
            itemId={itemid}
            tags={data.manutds && data.manutds.value && data.manutds.value.Tags}
            classes={isDestinationPage ? 'collection-destination' : null}
          ></Sponsor>
        </div>
        <div className="mu-item__info">
          {data.ShortHeadline && data.ShortHeadline.value && (
            <h2 className="mu-item__title" id="dialog1_label">
              {data.ShortHeadline.value}
            </h2>
          )}
          {data.Introduction && data.Introduction.value && (
            <p className="mu-item__teasure">{data.Introduction.value}</p>
          )}
          {!lastCard && (
            <div
              className="red-btn-skew"
              role="button"
              tabIndex="0"
              onClick={(e) => showCollectionCard(e)}
              onKeyDown={(e) => showCollectionCard(e)}
            >
              <span className="red-btn-skew-link">
                {t('exploreCollection')}
                <i className="tag-white-arrow"></i>
              </span>
            </div>
          )}
          {lastCard && (
            <React.Fragment>
              {upsell && <UpSell data={upsell} />}
              <div
                className="white-btn-skew-v2 share-button"
                tabIndex="0"
                aria-label={t('shareCollection')}
                role="link"
                onClick={(e) => shareCollection(e)}
              >
                <span className="red-btn-skew-link">{t('shareCollection')}</span>
                {/* PBL-1311 */}
                {/* <StatsBar
                  style={{
                    opacity: 1,
                  }}
                  classes="statsbar statsbar-lastcard"
                  item={getStatsBarData(data)}
                ></StatsBar> */}
              </div>
            </React.Fragment>
          )}
        </div>
      </div>
      <StatsBar item={getStatsBarData(data)}></StatsBar>
    </div>
  );
};
export default withTranslation()(CollectionExplore);
